import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState(email && token ? "ready" : "invalid");
  const [error, setError] = useState("");

  const confirm = async () => {
    setState("working");
    try {
      await api.post("/public/newsletter/unsubscribe", { email, token });
      setState("done");
    } catch (e) {
      setError(formatApiError(e));
      setState("error");
    }
  };

  return (
    <div className="mx-auto max-w-xl px-4 py-16 text-center" data-testid="unsubscribe-page">
      <h1 className="font-serif text-3xl font-bold text-cream-text">Unsubscribe from marketing emails</h1>

      {state === "invalid" && (
        <p className="mt-4 text-sm text-cream-muted" data-testid="unsubscribe-invalid">
          This unsubscribe link is incomplete. Please use the full link from your email, or contact us and we will remove you.
        </p>
      )}

      {state === "ready" && (
        <div className="mt-6">
          <p className="text-sm text-cream-muted">
            You are about to unsubscribe <span className="font-bold text-cream-text">{email}</span> from recipes and offers emails.
            This does not affect essential emails about your orders.
          </p>
          <button onClick={confirm} className="mt-6 rounded-full bg-gold px-6 py-3 text-sm font-bold text-choco transition-colors hover:bg-gold-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus" data-testid="unsubscribe-confirm-button">
            Confirm unsubscribe
          </button>
        </div>
      )}

      {state === "working" && <p className="mt-6 text-sm text-cream-muted">Unsubscribing…</p>}

      {state === "done" && (
        <div className="mt-6" data-testid="unsubscribe-success">
          <p className="text-sm text-cream-muted">
            <span className="font-bold text-cream-text">{email}</span> has been unsubscribed. We keep a suppression record so the address is not accidentally re-added.
            You will still receive essential emails about any orders you place.
          </p>
          <Link to="/" className="mt-6 inline-block rounded-full bg-gold px-6 py-3 text-sm font-bold text-choco hover:bg-gold-hover" data-testid="unsubscribe-home-link">Back to Bakes by CR</Link>
        </div>
      )}

      {state === "error" && (
        <p className="mt-6 text-sm text-red-400" data-testid="unsubscribe-error">{error}</p>
      )}
    </div>
  );
}
